module.exports = __webpack_public_path__ + "static/media/Norms.9b7f25f2.svg";